/**
 * Intercom powers the "ask for help" popup thing in the bottom right corner.
 * Help Desk can provide access.
 */
import React from 'react';
const intercomAppId = process.env.INTERCOM_APP_ID || 'dft0l0px';

export const IntercomTag = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
function detectmob() {
  if( navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)
  ){
    return true;
  }
  else {
    return false;
  }
}

function getGfoOrderId() {
  const params = new URLSearchParams(window.location.search)
  return params.get("order_number") 
}

function getGfoOrder() {
  const params = new URLSearchParams(window.location.search)
  var orderUrl = "https://api.chowbus.com/backend/"
  var orderType = params.get("order_type")

  if (orderType != null && orderType == 'GfoOnDemandOrder') {
    orderType = 'on-demand'
  } else if (orderType != null && orderType == 'GfoPickupOrder') {
    orderType = 'pickup'
  }

  var orderId = params.get("order_number")
  orderUrl = orderUrl + orderType + "/orders/" + orderId
  return orderUrl
}

function getGfoServiceRegion() {
  const params = new URLSearchParams(window.location.search)
  return params.get("service_region") 
}

function isEmpty(obj){
  if(typeof obj == "undefined" || obj == null || obj == ""){
      return true;
  }else{
      return false;
  }
}

var is_mobile = detectmob();
var gfoOrderId = getGfoOrderId();
 
if (!isEmpty(gfoOrderId)) {
  var gfoOrder = getGfoOrder()
  var gfoOrderServiceRegion = getGfoServiceRegion()
  //console.log(gfoOrderId);
  //console.log(gfoOrder);

  //console.log(gfoOrderServiceRegion);
  window.intercomSettings = {
    app_id: '${intercomAppId}',
    GFO_Order: gfoOrder,
    'Service Region': gfoOrderServiceRegion,
    'User Type': 'GFO_Diner',
    hide_default_launcher: is_mobile
  };
} else {
  window.intercomSettings = {
    app_id: '${intercomAppId}',
    hide_default_launcher: is_mobile
};
}


</script><script>(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${intercomAppId}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`,
      }}></script>
  );
};

class Intercom {
  logout() {
    window.Intercom('shutdown');
  }

  show() {
    window.Intercom('show');
  }

  boot(user) {
    let params = {
      app_id: intercomAppId,
      'User Type': 'Diner',
    };
    if (user) {
      const { id, email, created_at, first_name, last_name, hmac_digest } = user;
      params = {
        ...params,
        user_id: id,
        name: [first_name, last_name].join(' '),
        email,
        user_hash: hmac_digest,
        created_at,
        'Profile Page': `https://api.chowbus.com/backend/users/${id}`,
      };
    }
    window.Intercom('boot', params);
  }
}

export const intercom = new Intercom();
